<template>
  <b-tabs
    content-class="mt-3"
    small
    fill
  >
    <b-tab title="Images">
      <div class="content-module-cards mt-3">
        <div 
          class="card text-center h-100 hover-card"
          @click="addProductImages"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="file-earmark-image"
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Product Images
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addProductImagePlaceholder"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="plus-square-dotted" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Product Placeholder
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addProductDimensions"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="aspect-ratio" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Product Frame
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="showSmartObject"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="images" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Smart Object
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addImage"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="card-image" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Add Image
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Background Theme Image')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="filter-square" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Image Placeholder
            </p>
          </div>
        </div>
        
        <div 
          class="card text-center h-100 hover-card generate-background"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="stars" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Generate Image
            </p>
          </div>
        </div>

        <div
          class="card text-center h-100 hover-card translate-image"
          :data-id="selectedInstance.id"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="translate" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Translate Image
            </p>
          </div>
        </div>

        <div
          class="card text-center h-100 hover-card make-template-editable"
          :data-id="selectedInstance.id"
        >
          <div class="card-body">
            <h5 class="card-title">
              <img
                src="/img/icons/make-editable.png"
                width="30"
                height="30"
              >
            </h5>
            <p class="card-text">
              Make Editable
            </p>
          </div>
        </div>
        
        <div
          v-if="makeEditableV2UiEnabled"
          class="card text-center h-100 hover-card make-editable-v2"
          :data-id="selectedInstance.id"
        >
          <div class="card-body">
            <h5 class="card-title">
              <img
                src="/img/icons/make-editable.png"
                width="30"
                height="30"
              >
            </h5>
            <p class="card-text">
              Make Editable V2
            </p>
          </div>
        </div>
        
        <div
          class="card text-center h-100 hover-card extract-claims"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon
                icon="input-cursor-text"
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Extract Claims
            </p>
          </div>
        </div>
      </div>
    </b-tab>
    <b-tab title="Add Fields">
      <div class="content-module-cards mt-3">
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Multi Line Text')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="input-cursor-text"
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Text
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Rectangle')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="square" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Rectangle
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Circle')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="circle"
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Circle
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Safe Zone')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="x-square" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Safe Zone
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Icons')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="file-earmark-image"
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Icons
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Line')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="border-width" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Line
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Table')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="table"
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Table
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addAdditionalField('Cut Line')"
        >
          <div class="card-body">
            <h5 class="card-title">
              <b-icon 
                icon="scissors" 
                scale="1.5"
                class="icon-size"
              />
            </h5>
            <p class="card-text">
              Cut Line
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addCalloutField('Rectangle')"
        >
          <div class="card-body">
            <h5 class="card-title position-relative">
              <div class="position-relative text-center">
                <div class="t-icon-contaner">
                  <strong class="t-icon">T</strong>
                </div>
                <b-icon 
                  icon="input-cursor-text"
                  scale="1.5"
                  class="icon-size"
                />
              </div>
            </h5>
            <p class="card-text">
              Callout
            </p>
          </div>
        </div>
        <div 
          class="card text-center h-100 hover-card"
          @click="addProductDimensionsField"
        >
          <div class="card-body">
            <h5 class="card-title position-relative">
              <div class="position-relative text-center">
                <div class="t-icon-contaner">
                  <strong class="t-icon">T</strong>
                </div>
                <b-icon 
                  icon="aspect-ratio" 
                  scale="1.5"
                  class="icon-size"
                />
              </div>
            </h5>
            <p class="card-text">
              Product Dimensions
            </p>
          </div>
        </div>
      </div>
      <IconsSettingsModal ref="iconsSettingsModal" />
      <SimpleTableBuilderModal />
    </b-tab>
    <div class="my-3">
      <b-input
        v-model="fieldName"
        type="text"
        placeholder="Field name"
        class="form-control mb-2"
      />
      <div class="position-fixed apply-to-section">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <span>Add to</span>
            <PreviewsDropdown v-model="selectedInstancesIds" />
          </div>
        </div>
      </div>
    </div>
  </b-tabs>
</template>

<script>
/* global fontFamilyManager */
import { mapGetters } from 'vuex'
import { editorControlEventBroker, EVENTS } from '@frontend/group/modules/editor-control-popup/event-broker';
import {
  FIELD_TYPE_BACKGROND_THEME_IMAGE,
  FIELD_TYPE_CIRCLE, FIELD_TYPE_CUT_LINE, FIELD_TYPE_LINE,
  FIELD_TYPE_MULTI_LINE_TEXT,
  FIELD_TYPE_RECTANGLE,
  FIELD_TYPE_SAFE_ZONE
} from "@frontend/constants/type-fields-of-template";
import PreviewsDropdown from "@frontend/components/modules/layouts-page/EditorControl/components/PreviewsDropdown.vue";
import { initMakeTemplateImageEditableHandler } from "../../../../group/modules/make-template-image-editable/index.js";
import { initMakeEditableV2Handler } from "../../../../group/modules/make-editable-v2/index.js";
import { initTranslateTemplateImageHandler } from "../../../../group/modules/translate-template-image/index.js";
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";
const SUPPORTED_TYPES_FOR_MULTI_TEMPLATES_ADDING = [
    FIELD_TYPE_RECTANGLE,
    FIELD_TYPE_MULTI_LINE_TEXT,
    FIELD_TYPE_SAFE_ZONE,
    FIELD_TYPE_CIRCLE,
    FIELD_TYPE_LINE,
    FIELD_TYPE_BACKGROND_THEME_IMAGE,
    FIELD_TYPE_CUT_LINE
];

export default {
  name: 'ContentModule',
  components: {
    PreviewsDropdown,
  },
  props: {
    switchToTab: {
      type: Function,
      default: () => function () {}
    } 
  },
  data() {
    return {
      selectedInstancesIds: [],
      fieldName: '',
      makeEditableV2UiEnabled: true,
    };
  },
  computed: {
    ...mapGetters('layout', [
      'selectedInstance',
      'selectedInstanceIndex',
      'selectedInstanceFieldsWithType',
      'currentPagePreviews',
    ]),
    hasSmartObject() {
      return this.selectedInstance.template.fields.some(field => field.type === 'Smart Object');
    },
    hasProductDimensionsField(){
      return this.selectedInstance.template.fields.some(field => field.type === 'Product Dimensions');
    },
  },
  mounted() {
    this.initTemplateEditableHandler();
    this.initTranslateTemplateHandler();
  },
  methods: {
    initTemplateEditableHandler() {
      const row = this.$el; 
      initMakeTemplateImageEditableHandler($(row));
      if (this.makeEditableV2UiEnabled) {
        initMakeEditableV2Handler($(row));
      }
    },
    initTranslateTemplateHandler() {
      const row = this.$el; 
      initTranslateTemplateImageHandler($(row));
    },
    addProductImages () {
      this.selectedInstance.canvas.fire('add:product-images', {
        instanceId: this.selectedInstance.id,
        isNeedAddProductDimensionsField: false,
      })
    },
    addProductImagePlaceholder () {
      this.selectedInstance.canvas.fire('add:product-image-placeholder', {
        instanceId: this.selectedInstance.id,
        isNeedAddProductDimensionsField: false,
      })
    },
    addProductDimensions () {
      this.selectedInstance.canvas.fire('add:product-dimensions', {
        instanceId: this.selectedInstance.id,
        isNeedAddProductDimensionsField: false,
      })
    },
    async addProductDimensionsField() {
      this.handleFieldAddedAndShowSettings(this.selectedInstance.canvas);
      const canvas = this.selectedInstance.canvas;
      const fullWidth = canvas.width;
      const fullHeight = canvas.height;
      const activeObject = canvas.getActiveObject();
      const font = fontFamilyManager.fonts?.find(f => f.name === "Roboto Bold");
      const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

      // find background image element (if any)
      let element = null;
      if (!activeObject || activeObject.fieldType !== FIELD_TYPE_BACKGROND_THEME_IMAGE) {
        const candidates = canvas.getObjects()
          .filter(obj => obj.fieldType === FIELD_TYPE_BACKGROND_THEME_IMAGE && obj.width > 0);
        element = candidates.length ? candidates[0] : null;
      } else {
        element = activeObject;
      }

      // fallback marker and default element (smaller than full canvas so margins exist)
      let isFallback = false;
      if (!element) {
        isFallback = true;
        element = {
          width: fullWidth * 0.85,
          height: fullHeight * 0.85,
          scaleX: 1,
          scaleY: 1,
          left: fullWidth / 2,
          top: fullHeight / 2
        };
      }

      // scaled object dims & center
      const w = element.width * element.scaleX;
      const h = element.height * element.scaleY;
      const cx = element.left;
      const cy = element.top;

      // dynamic sizes
      let lengthSize = Math.max(40, w * (isFallback ? 0.40 : 0.35));
      const heightSize = Math.max(40, h * (isFallback ? 0.40 : 0.35));
      const widthSize  = Math.max(40, Math.sqrt(w * w + h * h) * (isFallback ? 0.40 : 0.35));

      // margins
      const marginX = Math.max(12, fullWidth * 0.03);
      const marginY = Math.max(12, fullHeight * 0.03);
      lengthSize = Math.min(lengthSize, Math.max(40, fullWidth - marginX * 2));

      // adaptive font
      const baseFont = Math.round(Math.max(18, Math.min(36, Math.min(w, h) * 0.06)));
      const lengthTextGap = Math.max(18, baseFont / 1.2);
      const lengthTextHeight = baseFont * 1.4;

      // helper to clamp coords inside canvas
      const clampX = x => Math.max(5, Math.min(x, fullWidth - 5));
      const clampY = y => Math.max(5, Math.min(y, fullHeight - 5));

      // ---------- LENGTH ----------
      let lengthX, lengthY;
      if (isFallback) {
        lengthX = fullWidth / 2 - lengthSize / 2;
        lengthY = fullHeight - 80;
      } else {
        lengthX = cx - lengthSize / 2;
        lengthY = cy + (h / 2) + Math.max(16, marginY);
      }
      lengthX = Math.max(marginX, Math.min(lengthX, fullWidth - marginX - lengthSize));
      lengthY = Math.max(5, Math.min(lengthY, fullHeight - marginY - lengthTextGap - lengthTextHeight));
      const lengthTextY = Math.max(5, Math.min(lengthY + lengthTextGap, fullHeight - marginY - lengthTextHeight));

      // line
      canvas.fire('add:additional-field', {
        instancesIds: [this.selectedInstance.id],
        type: FIELD_TYPE_LINE,
        options: {
          name: 'Length Line',
          _coords: [0, 0, lengthSize, 0],
          _offset_x: lengthX,
          _offset_y: lengthY,
          _angle: 0,
          stroke: 'black',
          strokeWidth: 4
        }
      });

      // text (centered, same width as line)
      canvas.fire('add:additional-field', {
        instancesIds: [this.selectedInstance.id],
        type: FIELD_TYPE_MULTI_LINE_TEXT,
        options: {
          name: 'Length Text',
          text: 'Length',
          _width: lengthSize,
          _color: '#000000',
          _fontsize: baseFont,
          _font: font?.index,
          _offset_x: clampX(cx),
          _offset_y: lengthTextY,
          _angle: 0,
          _align: 'center',
          _textAlign: 'center'
        }
      });
      await delay(500);

      // ---------- HEIGHT ----------
      let heightX, heightY;
      if (isFallback) {
        heightX = 80;
        heightY = fullHeight / 2 - heightSize / 2;
      } else {
        heightX = cx - (w / 2) - Math.max(16, marginX);
        heightY = cy - heightSize / 2;
      }
      heightX = clampX(heightX); heightY = clampY(heightY);

      // line (vertical)
      canvas.fire('add:additional-field', {
        instancesIds: [this.selectedInstance.id],
        type: FIELD_TYPE_LINE,
        options: {
          name: 'Height Line',
          _coords: [0, 0, heightSize, 0],
          _offset_x: heightX,
          _offset_y: heightY,
          _angle: 90,
          stroke: 'black',
          strokeWidth: 4
        }
      });

      // text (centered, same width as line)
      const heightTextGap = Math.max(36, baseFont);
      const heightTextCenterX = heightX - heightTextGap - (heightSize / 2);

      canvas.fire('add:additional-field', {
        instancesIds: [this.selectedInstance.id],
        type: FIELD_TYPE_MULTI_LINE_TEXT,
        options: {
          name: 'Height Text',
          text: 'Height',
          _width: heightSize,
          _color: '#000000',
          _fontsize: baseFont,
          _font: font?.index,
          _offset_x: clampX(heightTextCenterX),
          _offset_y: clampY(cy),
          _angle: 0,
          _align: 'center',
          _textAlign: 'center'
        }
      });
      await delay(500);

      // ---------- WIDTH ----------
      const angleDeg = -45;
      const angleRad = angleDeg * Math.PI / 180;
      const halfLen = widthSize / 2;
      const deltaX = widthSize * Math.cos(angleRad);
      const deltaY = widthSize * Math.sin(angleRad);

      const rightEdge = cx + w / 2;
      const rightBuffer = Math.max(12, marginX);

      if (isFallback) {
        const targetMidX = fullWidth / 2;
        const targetMidY = fullHeight / 2;
        let widthStartX = targetMidX - halfLen * Math.cos(angleRad);
        let widthStartY = targetMidY - halfLen * Math.sin(angleRad);

        widthStartX = clampX(widthStartX);
        widthStartY = clampY(widthStartY);

        const midX = widthStartX + halfLen * Math.cos(angleRad);
        const midY = widthStartY + halfLen * Math.sin(angleRad);

        const perpOffset = Math.max(12, Math.min(60, Math.min(w, h) * 0.04));
        const perpAngle = angleRad + Math.PI / 2;
        const textX = clampX(midX + perpOffset * Math.cos(perpAngle));
        const textY = clampY(midY + perpOffset * Math.sin(perpAngle));

        canvas.fire('add:additional-field', {
          instancesIds: [this.selectedInstance.id],
          type: FIELD_TYPE_LINE,
          options: {
            name: 'Width Line',
            _coords: [0, 0, widthSize, 0],
            _offset_x: widthStartX,
            _offset_y: widthStartY,
            _angle: angleDeg,
            stroke: 'black',
            strokeWidth: 4
          }
        });

        canvas.fire('add:additional-field', {
          instancesIds: [this.selectedInstance.id],
          type: FIELD_TYPE_MULTI_LINE_TEXT,
          options: {
            name: 'Width Text',
            text: 'Width',
            _width: widthSize,
            _color: '#000000',
            _fontsize: baseFont,
            _font: font?.index,
            _offset_x: textX,
            _offset_y: textY,
            _angle: angleDeg,
            _align: 'center',
            _textAlign: 'center'
          }
        });
      } else {
        const desiredStartX = rightEdge + rightBuffer;
        const maxStartX = fullWidth - 5 - deltaX;
        let widthStartX = Math.min(desiredStartX, maxStartX);
        widthStartX = Math.max(5, widthStartX);
        let widthStartY = cy - halfLen * Math.sin(angleRad);

        const startYMin = Math.min(widthStartY, widthStartY + deltaY);
        const startYMax = Math.max(widthStartY, widthStartY + deltaY);

        if (startYMin < 5) widthStartY += (5 - startYMin);
        else if (startYMax > fullHeight - 5) widthStartY -= (startYMax - (fullHeight - 5));

        widthStartX = clampX(widthStartX);
        widthStartY = clampY(widthStartY);

        const midX = widthStartX + halfLen * Math.cos(angleRad);
        const midY = widthStartY + halfLen * Math.sin(angleRad);

        const perpOffsetBase = Math.max(12, Math.min(60, Math.min(w, h) * 0.04));
        const perpAngle = angleRad + Math.PI / 2;
        let perpX = Math.cos(perpAngle);
        let perpY = Math.sin(perpAngle);
        const dot = perpX * (midX - cx) + perpY * (midY - cy);
        const perpOffset = dot < 0 ? -perpOffsetBase : perpOffsetBase;

        const textX = clampX(midX + perpOffset * perpX);
        const textY = clampY(midY + perpOffset * perpY);

        canvas.fire('add:additional-field', {
          instancesIds: [this.selectedInstance.id],
          type: FIELD_TYPE_LINE,
          options: {
            name: 'Width Line',
            _coords: [0, 0, widthSize, 0],
            _offset_x: widthStartX,
            _offset_y: widthStartY,
            _angle: angleDeg,
            stroke: 'black',
            strokeWidth: 4
          }
        });

        canvas.fire('add:additional-field', {
          instancesIds: [this.selectedInstance.id],
          type: FIELD_TYPE_MULTI_LINE_TEXT,
          options: {
            name: 'Width Text',
            text: 'Width',
            _width: widthSize,
            _color: '#000000',
            _fontsize: baseFont,
            _font: font?.index,
            _offset_x: textX,
            _offset_y: textY,
            _angle: angleDeg,
            _align: 'center',
            _textAlign: 'center'
          }
        });
      }
    },
    async addCalloutField (type) {
      this.handleFieldAddedAndShowSettings(this.selectedInstance.canvas);
      const font = fontFamilyManager.fonts?.find(f => f.name === "Roboto Bold");
      //rectangle height is 15% of template height
      const rectangleHeight = this.selectedInstance.template.height * 0.15;
      //font size is 40% of rectangle height
      const fontSize = parseInt(rectangleHeight * 0.4);      

      await document.fonts.load(`${fontSize}px "${font?.index}"`);
      const existingElementIds = this.selectedInstance.canvas.getObjects()
              .filter(obj => obj.fieldType === FIELD_TYPE_RECTANGLE)
              .map(obj => obj.element_id);
      //add rectangle field
      await this.selectedInstance.canvas.fire('add:additional-field', {
        instancesIds: [this.selectedInstance.id],
        type,
        options: {
          name: this.fieldName,
          _width: this.selectedInstance.template.width,
          _height: rectangleHeight,
          _offset_y: "30"
        }
      });
      
      //retrieve the newly added rectangle object
      const newRectangleObject =  this.selectedInstance.canvas.getObjects().filter(obj => {
        return obj.fieldType === FIELD_TYPE_RECTANGLE && !existingElementIds.includes(obj.element_id);
      })[0];
      const estimatedTextHeight = fontSize * (this.selectedInstance.data[`${newRectangleObject.element_id}_scaleX`] || 1);

      //add text field
      type = 'Multi Line Text';
      await this.selectedInstance.canvas.fire('add:additional-field', {
        instancesIds: [this.selectedInstance.id],
        type,
        options: {
          name: this.fieldName,
          _width: this.selectedInstance.template.width,
          _color: '#ffffff',
          _fontsize: fontSize,
          _font: font?.index,
          _offset_x: "30",
          _offset_y: newRectangleObject.top + (rectangleHeight - estimatedTextHeight) / 2
        }
      });
    },
    addAdditionalField (type) {
      const isMultiTemplateAddingSupported = SUPPORTED_TYPES_FOR_MULTI_TEMPLATES_ADDING.includes(type);
      
      this.handleFieldAddedAndShowSettings(this.selectedInstance.canvas);
      
      this.selectedInstance.canvas.fire('add:additional-field', {
        instancesIds: isMultiTemplateAddingSupported ? this.selectedInstancesIds : [this.selectedInstance.id],
        type,
        options: {
          name: this.fieldName,
          deleteWhenUserClosesImageSelectionModal: true,
        }
      })
    },
    showSmartObject () {
      const {getUserLayersOrder} = ShowPageScopeCollector.get([
        'rerenderTemplates',
        'getUserLayersOrder',
      ]);
      const instance_id = this.selectedInstance.id;
      const template_width = this.selectedInstance.template?.width;
      const template_height = this.selectedInstance.template?.height;
      let users_fields_order = this.selectedInstance.data.users_fields_order ? JSON.parse(this.selectedInstance.data.users_fields_order) : false;
      let usersOrderData = null;
      if (!users_fields_order) {
        usersOrderData = getUserLayersOrder(instance_id);
      }
      this.selectedInstance.canvas.fire('add:smart-object-field', {
        instanceId: this.selectedInstance.id,
        type: 'Smart Object',
        options: {
          template_width: template_width,
          template_height: template_height,
          users_fields_order: usersOrderData ? usersOrderData.orders : users_fields_order,
        }
      })
      this.switchToTab(0)
    },
    addImage() {
      this.switchToTab(0);
      // force the click to the base directory
      document.querySelector('.back-to-folder-link').click();
      const totalExpectedNewObjects = this.selectedInstancesIds.length;
      const newObjects = [];

      const previews = window.previews.filter(preview => this.selectedInstancesIds.includes(preview.id));

      for (const preview of previews) {
        const existingElementIds = new Set();
        const existingIds = new Set();

        const currentObjects = this.selectedInstance.canvas.getObjects();
        currentObjects.forEach((obj, index) => {
          if (obj.element_id) existingElementIds.add(obj.element_id);
          if (obj.id) existingIds.add(obj.id);
        });

        preview.canvas.once('object:added', (e) => {
          setTimeout(() => {
            const updatedObjects = this.selectedInstance.canvas.getObjects();

            let newObject = null;

            updatedObjects.forEach((obj, index) => {
              if (obj.element_id && !existingElementIds.has(obj.element_id)) {
                newObject = obj;
              }
              else if (obj.id && !existingIds.has(obj.id)) {
                if (!newObject) newObject = obj;
              }
            });

            if (!newObject && updatedObjects.length > currentObjects.length) {
              newObject = updatedObjects[updatedObjects.length - 1];
            }
            
            newObjects.push({ instanceId: preview.id, objects: [newObject] });

            if (newObjects.length === totalExpectedNewObjects) {
              this.selectedInstance.canvas.setActiveObject(newObject);
              this.selectedInstance.canvas.renderAll();

              //add data to modal 
              $('#selectBkImgModal').data('fromAddImage', true);
              editorControlEventBroker.fire(EVENTS.IMAGE_CHANGED, {
                action: 'selectBackground',
                targets: newObjects
              });
            }
          }, 50);
        });
      }
      
      this.addAdditionalField('Background Theme Image');
    },
    handleFieldAddedAndShowSettings(canvas) {
      canvas.once('object:added', (e) => {
        const newObject = e.target;
        if (newObject) {
          canvas.setActiveObject(newObject);
          canvas.renderAll();
          this.switchToTab(0);
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.content-module-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 90px;
  gap: 16px;
}
.btn-group-vertical {
  width: 100%;

  .btn {
    display: flex;
    align-items: center;

    .b-icon {
      margin-right: .5rem;
    }
  }
}

.hover-card {
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border 0.2s ease;
  border-radius: 8px;
  border: 2px solid #d0d0d0;
}
.hover-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  border-color: #10b981;
  background: #f0fdf4;
  .icon-size {
    color: #10b981;
  }
  p {
    color: #10b981;
  }
  .t-icon {
    color: #10b981;
  }
}
.card-body {
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  justify-content: center;
  align-items: center;
}
.card-title {
  margin-bottom: 0.25rem;
}
.card-text {
  font-size: 0.9rem;
  margin-bottom: 0;
}
.t-icon-contaner {
  position: absolute; 
  top: 30%; 
  left: 10%; 
  transform: translateX(-50%); 
  font-size: 0.5rem;
}
.apply-to-section{
  bottom: 44px;
  z-index: 1;
}

</style>
